import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 px-6" }
const _hoisted_2 = { class: "flex flex-col space-y-1" }
const _hoisted_3 = { class: "flex flex-col space-y-1" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dx_date_box = _resolveComponent("dx-date-box")!
  const _component_grid = _resolveComponent("grid")!
  const _component_file_type_selector = _resolveComponent("file-type-selector")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "have-modal": _ctx.haveModal,
    "is-displayed": _ctx.isReportModalOpened,
    "no-padding": true,
    "remove-outside-click": true,
    title: `Generate report for ${_ctx.deviceName}`,
    onToggleModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_grid, { "column-number": 2 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "From", -1)),
                    _createVNode(_component_dx_date_box, {
                      modelValue: _ctx.from,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.from) = $event)),
                      height: 46,
                      "show-clear-button": true,
                      "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                      type: "datetime"
                    }, null, 8, ["modelValue", "display-format"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "To", -1)),
                    _createVNode(_component_dx_date_box, {
                      modelValue: _ctx.to,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.to) = $event)),
                      height: 46,
                      "show-clear-button": true,
                      "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                      type: "datetime"
                    }, null, 8, ["modelValue", "display-format"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_file_type_selector, {
                "selected-file-type": _ctx.selectedFileType,
                onSelectFileType: _ctx.changeFileTypeSelection
              }, null, 8, ["selected-file-type", "onSelectFileType"]),
              _createVNode(_component_grid, { "column-number": 2 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Language", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedLanguage,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                      options: _ctx.options,
                      reduce: (lang) => lang.id,
                      class: "mt-1",
                      label: "name"
                    }, {
                      option: _withCtx((option) => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            src: option.image,
                            alt: "image",
                            class: "w-[24px]"
                          }, null, 8, _hoisted_6),
                          _createElementVNode("p", null, _toDisplayString(option.name), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "reduce"])
                  ]),
                  _createVNode(_component_input_field, {
                    modelValue: _ctx.offset,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.offset) = $event)),
                    "no-padding": true,
                    label: "Time offset",
                    type: "number"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["have-modal", "is-displayed", "title"]))
}